export default __webpack_public_path__ + "static/media/image_14.c47db709.jpg";